import { updateObject } from "utils/helpers/updateObject";
import {
  actionTypes,
  VideoGroupsActions,
  stateStatusType,
  FetchAvatarImageRequestAction,
  FetchAvatarImageSuccessAction,
  FetchAvatarImageFailureAction,
  CreateAvatarImageFailAction,
  CreateAvatarImageSuccessAction,
  DeleteAvatarImageSuccessAction,
  DeleteAvatarImageRequestAction,
  DeleteAvatarImageFailAction,
} from "./actionType";
import { AvatarImageState, initialState } from "./state";

//FetchAvatarImageRequest
const FetchAvatarImageRequest = (
  state: AvatarImageState,
  action: FetchAvatarImageRequestAction
) => {
  return updateObject(state, {
    avatarImageState: {
      ...state.avatarImageState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const FetchAvatarImageSuccess = (
  state: AvatarImageState,
  action: FetchAvatarImageSuccessAction
) => {
  return updateObject(state, {
    avatarImageState: {
      ...state.avatarImageState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      avatarsImage: action.payload,
    },
  });
};

const FetchAvatarImageFail = (
  state: AvatarImageState,
  action: FetchAvatarImageFailureAction
) => {
  return updateObject(state, {
    avatarImageState: {
      ...state.avatarImageState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      avatarsImage: null,
    },
  });
};

const CreateAvatarImageSuccess = (
  state: AvatarImageState,
  action: CreateAvatarImageSuccessAction
) => {
  const newAvatarImages = state.avatarImageState.avatarsImage ?? [];
  return updateObject(state, {
    avatarImageState: {
      ...state.avatarImageState,
      isLoading: false,
      avatarsImage: [...newAvatarImages, action.payload],
      error: null,
    },
  });
};
const CreateAvatarImageFail = (
  state: AvatarImageState,
  action: CreateAvatarImageFailAction
) => {
  return updateObject(state, {
    avatarImageState: {
      ...state.avatarImageState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};
//deleteAvatarImageSuccess
const DeleteAvatarImageRequest = (
  state: AvatarImageState,
  action: DeleteAvatarImageRequestAction
) => {
  return updateObject(state, {
    avatarImageState: {
      ...state.avatarImageState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const DeleteAvatarImageSuccess = (
  state: AvatarImageState,
  action: DeleteAvatarImageSuccessAction
) => {
  const newAvatarImages = state.avatarImageState.avatarsImage?.filter(
    (image) => image.id !== action.payload
  );
  return updateObject(state, {
    avatarImageState: {
      ...state.avatarImageState,
      isLoading: false,
      avatarsImage: newAvatarImages,
      error: null,
    },
  });
};

const DeleteAvatarImageFail = (
  state: AvatarImageState,
  action: DeleteAvatarImageFailAction
) => {
  return updateObject(state, {
    avatarImageState: {
      ...state.avatarImageState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
}

const avatarImageReducer = (
  state = initialState,
  action: VideoGroupsActions
) => {
  switch (action.type) {
    case actionTypes.FETCH_AVATAR_IAMGE_REQUEST:
      return FetchAvatarImageRequest(state, action);
    case actionTypes.FETCH_AVATAR_IAMGE_SUCCESS:
      return FetchAvatarImageSuccess(state, action);
    case actionTypes.FETCH_AVATAR_IAMGE_FAIL:
      return FetchAvatarImageFail(state, action);
    case actionTypes.CREATE_AVATAR_IAMGE_SUCCESS:
      return CreateAvatarImageSuccess(state, action);
    case actionTypes.CREATE_AVATAR_IAMGE_FAIL:
      return CreateAvatarImageFail(state, action);
    case actionTypes.DELETE_AVATAR_IAMGE_REQUEST:
      return DeleteAvatarImageRequest(state, action);
    case actionTypes.DELETE_AVATAR_IAMGE_SUCCESS:
      return DeleteAvatarImageSuccess(state, action);
    case actionTypes.DELETE_AVATAR_IAMGE_FAIL:
      return DeleteAvatarImageFail(state, action);
    default:
      return state;
  }
};

export default avatarImageReducer;
